module.exports = __webpack_public_path__ + "img/5-en.b0745296.jpg";